// extracted by mini-css-extract-plugin
module.exports = {"vouchersPage":"styles_vouchersPage__xRPe9","primarySection":"styles_primarySection__l6JqY"};